import React, { useEffect, useRef } from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';

import { CloseIcon } from 'assets/images';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import setAccessibilityFocusTo from 'services/accessibility/setAccessibilityFocusTo';

import SvgButton from 'components/CustomButtons/SvgButton';
import LoadingCircle from 'components/Spinner';

import styles from './styles';

type Props = {
    loadingCirclePaddingBottom?: number;
    color?: string;
    onClose?: () => void;
    seeking?: boolean;
    embedded?: boolean;
    waiting?: boolean;
    routeKey: string;
};

const {
    ACCESSIBILITY: {
        PLAYER: { ACCESSIBILITY_PLAYER_CLOSE },
    },
} = LANGUAGE_KEYS;

function PlayerOverlayLoading({
    loadingCirclePaddingBottom = 0,
    color,
    onClose,
    seeking,
    embedded,
    waiting,
    routeKey,
}: Props) {
    const { t } = useTranslation();
    const closeRef = useRef(null);

    useEffect(() => {
        setAccessibilityFocusTo(closeRef);
    }, []);

    return (
        <View
            style={styles.loadingContainer}
            pointerEvents="box-none"
            accessible={false}
        >
            <LoadingCircle
                style={[
                    styles.loading,
                    {
                        paddingBottom: loadingCirclePaddingBottom,
                    },
                ]}
                color={color}
                routeKey={routeKey}
            />
            {!seeking && !embedded && !waiting ? (
                <SvgButton
                    ref={closeRef}
                    accessible
                    accessibilityLabel={t(ACCESSIBILITY_PLAYER_CLOSE)}
                    accessibilityRole="button"
                    Svg={CloseIcon}
                    style={styles.closeButton}
                    svgStyle={styles.closeSvg}
                    onPress={onClose}
                />
            ) : null}
        </View>
    );
}

export default PlayerOverlayLoading;
